// import pages
import * as Sentry from "@sentry/browser";
import { createRoot } from "react-dom/client";

import App from "./App";
import { AlertProvider } from "./constants/AlertProvider";
import { ModeProvider } from "./constants/ModeProvider";
import { ThemeProvider } from "./constants/ThemeProvider";

import "../css/output.css";

Sentry.init({
  dsn: window.SENTRY_DSN,
  release: window.COMMIT_SHA,
});

const root = createRoot(document.getElementById("react-app") as HTMLElement);
root.render(
  <ThemeProvider>
    <AlertProvider>
      <ModeProvider>
        <App />
      </ModeProvider>
    </AlertProvider>
  </ThemeProvider>,
);
